import React from 'react';
import SponsorPart from './components/SponsorPart';
import './Sponsors.scss';

const organizersImgs = [
  {
    src: 'imgs/logos/accenture.png',
    alt: 'Accenture',
    imgWidthLarge: '20%',
    imgWidthDesktop: '30%',
    imgWidthTablet: '40%',
    imgWidthMobile: '90%',
    classes: 'is-full',
    url: 'https://careers.accenture.com/sk-sk/Pages/index.aspx'
  }
];

const platinumPartner = [
  {
    src: 'imgs/logos/redhat.png',
    alt: 'Google Cloud',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    // classes: 'is-4-desktop is-full-mobile logo-margin',
    classes: 'is-full',
    url: 'https://www.redhat.com/en/partners/accenture'
  }
];

const partnersImgs = [
  {
    src: 'imgs/logos/siemens.png',
    alt: 'Siemens',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-6-desktop is-full-mobile logo-margin',
    url: 'https://new.siemens.com/sk/sk/spolocnost/kariera.html'
  },
  {
    src: 'imgs/logos/GoogleCloud.png',
    alt: 'Google Cloud',
    imgWidthLarge: '270px',
    imgWidthDesktop: '270px',
    imgWidthTablet: '270px',
    imgWidthMobile: '270px',
    classes: 'is-6-desktop is-full-mobile logo-margin',
    url: 'https://cloud.google.com/'
  },
  {
    src: 'imgs/logos/takeda_logo.png',
    alt: 'Takeda',
    imgWidthLarge: '270px',
    imgWidthDesktop: '270px',
    imgWidthTablet: '270px',
    imgWidthMobile: '270px',
    classes: 'is-6-desktop is-full-mobile logo-margin',
    url: 'https://www.takeda.com/'
  },
  {
    src: 'imgs/logos/jb_beam.png',
    alt: 'Jetbrains',
    imgWidthLarge: '120px',
    imgWidthDesktop: '120px',
    imgWidthTablet: '120px',
    imgWidthMobile: '120px',
    classes: 'is-6-desktop is-full-mobile logo-margin',
    url: 'https://www.jetbrains.com/'
  }
];

const mediaPartnersImgs = [
  {
    src: 'imgs/logos/robimeit.png',
    alt: 'RobimeIT',
    imgWidthLarge: '200px',
    imgWidthDesktop: '200px',
    imgWidthTablet: '200px',
    imgWidthMobile: '200px',
    // classes: 'is-6-desktop is-full-mobile logo-margin',
    classes: 'is-full',
    url: 'https://robime.it/'
  }
  // {
  //   src: 'imgs/logos/touchit.png',
  //   alt: 'TouchIt',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://touchit.sk/'
  // },
  // {
  //   src: 'imgs/logos/NEXTECH.jpg',
  //   alt: 'Nextech',
  //   imgWidthLarge: '200px',
  //   imgWidthDesktop: '200px',
  //   imgWidthTablet: '200px',
  //   imgWidthMobile: '200px',
  //   classes: 'is-6-desktop is-full-mobile logo-margin',
  //   url: 'https://www.pcrevue.sk/pc-revue'
  // },
  // {
  //   src: 'imgs/logos/zive.jpg',
  //   alt: 'Zive',
  //   imgWidthLarge: '150px',
  //   imgWidthDesktop: '150px',
  //   imgWidthTablet: '150px',
  //   imgWidthMobile: '150px',
  //   classes: 'is-6-desktop is-full-mobile',
  //   url: 'https://zive.aktuality.sk/'
  // }
];

const supportersImgs = [
  {
    src: 'imgs/logos/GoogleDevelopers.png',
    alt: 'Google Developers',
    imgWidthLarge: '250px',
    imgWidthDesktop: '250px',
    imgWidthTablet: '250px',
    imgWidthMobile: '250px',
    classes: 'is-full',
    url: 'https://developers.google.com/'
  }
];

const Sponsors = () => (
  <section className="section" id="sponsors">
    <SponsorPart imgs={organizersImgs} title="ORGANIZERS" />
    <SponsorPart imgs={platinumPartner} title="PLATINUM PARTNER" />
    <SponsorPart imgs={partnersImgs} title="PARTNERS" />
    <SponsorPart imgs={mediaPartnersImgs} title="MEDIA PARTNERS" />
    <SponsorPart imgs={supportersImgs} title="SUPPORTERS" />
  </section>
);

export default Sponsors;
